import React from 'react';
import withContext from '../ContextAPI/Context_HOC';
import { withRouter } from 'react-router-dom';

function MainGlsa() {
  return (
    <div>
      <h1>Guidelines for LSAs</h1>
      <p>
        Originally produced in 1989, Guidelines for Local Spiritual Assemblies or GLSA, formerly known as{' '}
        <em>Developing Distinctive Bahá’í Communities: Guidelines for Local Spiritual Assemblies</em>, is a standard reference for
        authoritative guidance and national policies on facilitating the administration of community life by Local Spiritual
        Assemblies. The National Spiritual Assembly encourages all Local Assemblies to access and use this manual in preparation
        for and during Assembly meetings to clarify and deepen their understanding of relevant guidance necessary for their work.
      </p>
      <p>
        <em>Guidelines for Local Spiritual Assemblies</em> is available in electronic form only and is periodically updated.
        Please note that you have the National Assembly’s permission to make copies of portions of the manual for the use of your
        Local Assembly. Should you have any questions about the GLSA, please feel free to contact the Office of Community
        Administration by email at <a href="mailto:community@usbnc.org">community@usbnc.org</a> or by telephone at{' '}
        <a href="tel:847-733-3593">847-733-3593</a>.
      </p>
      <p>
        The latest edition of the GLSA (i.e., the February 2025 edition) aligns the organization and content of GLSA more closely
        with the framework for action in which the Bahá’í world is learning to operate during the Nine Year Plan. The chapters and
        major sections are organized such that the overarching purposes and principles related to particular topics, which are
        found in the Sacred Writings and the guidance of Shoghi Effendi and the Universal House of Justice, appear at the
        beginning. In this way, it is hoped that the relationships between these purposes and principles and the specific policies
        and procedures that stem from them can be more clearly seen. At present, you can download the entire February 2025 edition
        of the GLSA as a PDF document. An improved online version will be available in the future.
      </p>
      <br />
      <h4>
        <strong>Download: </strong>
        <a href="https://bahai-web.s3.us-east-1.amazonaws.com/forms/Assemblies%26Communities/Feb_2025_edition_Guidelines_for_Local_+Spiritual_+Assemblies_ver.02.pdf">
          Guidelines for Local Spiritual Assemblies
        </a>{' '}
        - <em>February 2025 edition</em>
      </h4>
      <hr />
      <h4 id="SupplementsGuideLine" className="anchor-heading">
        Supplements to <em>Guidelines for Local Spiritual Assemblies</em>
      </h4>
      <ul className="plain-list">
        <li>
          <strong>Download: </strong>
          <a href="https://bahai-web.s3.us-east-1.amazonaws.com/forms/Assemblies%26Communities/Archival+Records+for+Assemblies+(March%2C+2025).pdf">
            Archival Records for Assemblies – revised March 2025 (PDF)
          </a>
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://s3.amazonaws.com/bahai-web/tab/forms/BIA-Security-5.pdf">
            Computer Security for Bahá’í Institutions (PDF)
          </a>
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://bahai-web.s3.amazonaws.com/tab/forms/2021-confidentiality-LSA-docs.pdf">
            Confidentiality Policy and Form (English and Persian) (PDF)
          </a>
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://s3.amazonaws.com/bahai-web/tab/forms/oad-glsa-0911_dvs.pdf">
            Domestic Violence Supplement to Guidelines (PDF)
          </a>
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://s3.amazonaws.com/bahai-web/tab/forms/oad-glsa-0911_dvs_Persian.pdf">
            Domestic Violence Supplement to Guidelines (Persian) (PDF)
          </a>
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://s3.amazonaws.com/bahai-web/tab/forms/oad-emergency-contact-info-sheet.pdf">
            Emergency Contact Information Sheet (PDF)
          </a>
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://bahai-web.s3.us-east-1.amazonaws.com/forms/Assemblies%26Communities/Navigating+PDF+of+GLSA+Feb.+2025+edition.pdf">
            Navigating PDF of GLSA Feb. 2025 edition (PDF)
          </a>
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://s3.amazonaws.com/bahai-web/tab/eso/sc-2012-child-protection-form.pdf">
            Protection of Minors - Form(s) (PDF)
          </a>
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://bahai-web.s3.amazonaws.com/forms/Assemblies%26Communities/Guiding-Principles-and-Standards-Pertaining-to-the-Protection-of-Minors-revised-January-2023.pdf">
            Protection of Minors – Guiding Principles – revised January 2023 (PDF)
          </a>
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://bahai-web.s3.amazonaws.com/forms/Assemblies%26Communities/Policy+for+the+Protection+of+Children%2C+Junior+Youth%2C+and+Youth+-+July+2024.pdf">
            Protection of Minors – Policy – revised July 2024 (PDF)
          </a>
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://s3.amazonaws.com/bahai-web/tab/forms/opa-annual-guide.pdf">
            Public Affairs Annual Opportunities Guide (PDF)
          </a>
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://bahai-web.s3.amazonaws.com/forms/Assemblies%26Communities/Public-Affairs-Policies-Guidelines-2017.pdf">
            Public Affairs Policies and Guidelines (PDF)
          </a>
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://bahai-web.s3.amazonaws.com/forms/Assemblies%26Communities/Resources+for+Local+Spiritual+Assemblies+rev+2024-06-25.docx">
            Resources for LSAs - revised June 2024 (DOCX)
          </a>
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://bahai-web.s3.amazonaws.com/forms/Assemblies%26Communities/OAD_Some+thoughts+on+Assembly+operational+practices_v15_July+2024.pdf">
            Some Thoughts on Operational Practices of the LSA (PDF)
          </a>
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://bahai-web.s3.amazonaws.com/tab/forms/Year+of+Waiting+and+Divorce+Flowchart+for+LSAs.pdf">
            Year of Waiting Flowchart for LSAs (PDF)
          </a>
        </li>
      </ul>
    </div>
  );
}

export default withRouter(withContext(MainGlsa));
